import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "../../view/Dashboard";

import Setting from "../../view/Setting/components/Setting";
// import Distributor from "../../view/Distributor/";
// import Organisation from "../../view/Organisation/index";
// import Designation from "../../view/Designation/index";
// import Item from "../../view/Item/index";
// import Form from "../../view/Form/index";

// import Price from "../../view/Price/index";
// import PriceDetails from "../../view/Price/Components/PriceDetails";

// import Login from "../../view/login/Login";
// import Employee from "../../view/Employee";
// import Branch from "../../view/Branch";
// import ItemCategory from "../../view/ItemCategory";
// import Role from "../../view/Role";
// import Unit from "../../view/Unit";
// import Task from "../../view/Task";

// import State from "../../view/State/index";
// import Cart from "../../view/Cart/index";
// import Order from "../../view/Order/index";
// import OrderDetails from "../../view/Order/components/OrderDetails";
// import Department from "../../view/Department/index";
// import Customer from "../../view/Customer"
import NewBom from "../../view/Production/NewBom";
import BOM from "../../view/Production/BomList";
import Production from "../../view/productionPlanning";
import RawMaterial from "../../view/RawMaterial";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />}></Route>
      {/* <Route path="/setting" element={<Setting />}></Route> */}
      {/* <Route path="/new/BOM" element={<NewBom />}></Route>
      <Route path="/BOM/List" element={<BOM />}></Route> */}
      <Route path="/production" element={<Production />}></Route>
      <Route path="/rawMaterial" element={<RawMaterial />}></Route>

      <Route path="/*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default AppRoutes;
